import React from 'react';
import { createRoot } from 'react-dom/client';
import { DocumentViewer } from './components/DocumentViewer';
import './styles.css';

const token = new URLSearchParams(window.location.search).get('token');

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {token
      ? <DocumentViewer token={token} />
      : <main className="notice">
          <h1>This link is missing its token</h1>
          <p>Open the document from the link you were sent.</p>
        </main>}
  </React.StrictMode>,
);
